require ("./iconWithDescriptionList.scss")

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'
import { IconWithDescriptionItem } from './iconWithDescriptionItem';

const IconWithDescriptionList = (props) => {
    const { align, iconsWithBackground, items } = props

    const col = Math.floor(12 / items.length);
    const listClassName = classNames("description-and-icon__list row",
        {
            [`description-and-icon__list--${align}`]: align
        })

    return (
        <div className={listClassName}>
            {items.map((i, index) => (
                <IconWithDescriptionItem
                    align={align}
                    key={index}
                    iconsWithBackground={iconsWithBackground}
                    icon={i.icon}
                    text={i.text}
                    title={i.title}
                    col={col}
                />
            ))}
        </div>
    )
}

IconWithDescriptionList.propTypes = {
    align: PropTypes.oneOf(['left', 'right', 'center']),
    iconsWithBackground: PropTypes.bool,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            text: PropTypes.string,
            title: PropTypes.string
        })
    )
}

IconWithDescriptionList.defaultProps = {
    align: 'left',
    iconsWithBackground: false,
    items: []
}

export { IconWithDescriptionList };